// ============================================================================
// todo-client-mod -- 状态徽章
//
// 展示 Todo 状态的彩色徽章，根据主题自适应。
// ============================================================================
import * as React from 'react';
import { useTheme } from '../styles/use-theme.js';
import { getStatusColors, radius, typography } from '../styles/theme.js';
/** 状态文案映射 */
export const TODO_STATUS_LABELS = {
    pending: '待处理',
    in_progress: '进行中',
    completed: '已完成',
    cancelled: '已取消',
};
const STATUS_DECORATION = {
    pending: 'none',
    in_progress: 'none',
    completed: 'none',
    cancelled: 'line-through',
};
export function TodoStatusBadge({ status, size = 'sm' }) {
    const { theme } = useTheme();
    const colors = getStatusColors(status);
    return React.createElement('span', {
        style: {
            display: 'inline-block',
            padding: size === 'sm' ? '2px 8px' : '3px 10px',
            borderRadius: radius.sm,
            fontSize: size === 'sm' ? typography.fontSize.xs : typography.fontSize.sm,
            fontWeight: typography.fontWeight.medium,
            lineHeight: '18px',
            whiteSpace: 'nowrap',
            textDecoration: STATUS_DECORATION[status],
            color: colors.text,
            backgroundColor: colors.bg,
            border: colors.border ? `1px solid ${colors.border}` : 'none',
            transition: 'background-color 0.2s, color 0.2s',
        },
    }, TODO_STATUS_LABELS[status]);
}
//# sourceMappingURL=todo-status-badge.js.map